import type { SVGProps } from "react";
export function OutputIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m2.32709 2.9757c1.2382-1.22166 2.93894-1.9757 4.81579-1.9757 3.78712 0 6.85712 3.07004 6.85712 6.85713 0 3.78707-3.07 6.85717-6.85712 6.85717-1.87685 0-3.57759-.7541-4.81579-1.9758"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
      <path
        d="m6.20778 4.42857-3.2941 2.8061c-.47546.40502-.46741 1.14194.01679 1.53648l3.27731 2.67035"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        d="m9.63641 8.76298c.41419 0 .74999-.33579.74999-.75 0-.41422-.3358-.75-.74999-.75v.75zm-7.28569-.75v.75h7.28569v-.75-.75h-7.28569z"
        fill="currentColor"
      />
    </svg>
  );
}
